import {__, sprintf} from '@wordpress/i18n';
import {select} from '@wordpress/data';
import {TextControl, ToggleControl} from '@wordpress/components';
import {decodeEntities} from '@wordpress/html-entities';
import {usePostMeta} from '@lipemat/js-boilerplate-gutenberg';
import {CONFIG} from '../../../globals/config';
import type {FunctionComponent} from 'react';

type Meta = {
	'advanced-sidebar-menu/link-title': string;
	'advanced-sidebar-menu/exclude-page': boolean;
};

type Props = Record<string, never>;


const MetaBox: FunctionComponent<Props> = () => {
	const [ title, setTitle ] = usePostMeta<Meta, 'advanced-sidebar-menu/link-title'>( CONFIG.fields.title );
	const [ exclude, setExclude ] = usePostMeta<Meta, 'advanced-sidebar-menu/exclude-page'>( CONFIG.fields.excludePage );

	const post = select( 'core/editor' )?.getCurrentPost() ?? null;
	const postType = select( 'core/editor' )?.getCurrentPostType() ?? '';
	if ( null === post || '' === postType ) {
		return null;
	}

	return (
		<>
			<TextControl
				label={__( 'Title', 'advanced-sidebar-menu' )}
				placeholder={decodeEntities( post.title )}
				value={title}
				help={/* translators: %s: Post type name */
					sprintf( __( 'Title used for this %s\'s link when it is displayed in the Advanced Sidebar menus.', 'advanced-sidebar-menu' ), postType )}
				onChange={value => {
					setTitle( value );
				}}
				// @ts-expect-error -- Not technically supported until WP 6.7
				__nextHasNoMarginBottom
			/>
			<ToggleControl
				label={__( 'Excluded', 'advanced-sidebar-menu' )}
				checked={exclude}
				onChange={setExclude}
				help={/* translators: %s: Post type name */
					sprintf( __( 'Exclude this %s from all Advanced Sidebar menus.', 'advanced-sidebar-menu' ), postType )} />
		</>
	);
};

export default MetaBox;
